import { render, staticRenderFns } from "./SurveyPercentage.vue?vue&type=template&id=208d6f92&"
import script from "./SurveyPercentage.vue?vue&type=script&lang=ts&"
export * from "./SurveyPercentage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports